import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import Schema_Quote from '@flows/insurance/schemas/shared/Schema_Quote'

const liability_quote = <TDefaultStepConfig extends AnyStepConfiguration>(
  params: StepConfigParams,
  defaultStepConfig: TDefaultStepConfig
) => {
  return {
    ...defaultStepConfig,
    validationStrategy: 'onChange',
    schema: Schema_Quote,
    stepContent: [
      {
        type: 'customComponent',
        name: 'Summary',
        props: {
          products: [params.productKey],
        },
        inputs: [],
        outputs: [params.helperFunctions.getParamPath('drones_coverage')],
      },
    ],
    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'prepareConfigurationSummary',
        inputs: [],
        outputs: [],
      },
    },
    showOrderSummary: true,
  } as const satisfies AnyStepConfiguration
}

export default liability_quote
